/**
 * Utility functions for managing invite-related data in localStorage
 */

const PENDING_INVITE_CODE_KEY = 'pendingInviteCode'
const PENDING_INVITE_EMAIL_KEY = 'pendingInviteEmail'
const PENDING_INVITE_CODE_TIMESTAMP_KEY = 'pendingInviteCodeTimestamp'


export function isValidInviteCode(code: string | null): boolean {
	return code !== null && code.startsWith('inv')
}

export function getPendingInviteCode(): string | null {
	try {
		const code = localStorage.getItem(PENDING_INVITE_CODE_KEY)
		return isValidInviteCode(code) ? code : null
	} catch (e) {
		console.error('Error reading pending invite code from localStorage:', e)
		return null
	}
}

export function setPendingInviteCode(code: string | null): boolean {
	try {
		if (!code || !isValidInviteCode(code)) {
			return false
		}
		localStorage.setItem(PENDING_INVITE_CODE_KEY, code)
		localStorage.setItem(PENDING_INVITE_CODE_TIMESTAMP_KEY, Date.now().toString())
		return true
	} catch (e) {
		console.error('Error storing pending invite code in localStorage:', e)
		return false
	}
}

export function getPendingInviteEmail(): string | null {
	try {
		return localStorage.getItem(PENDING_INVITE_EMAIL_KEY)
	} catch (e) {
		console.error('Error reading pending invite email from localStorage:', e)
		return null
	}
}

export function setPendingInviteEmail(email: string | null): void {
	try {
		if (email) {
			localStorage.setItem(PENDING_INVITE_EMAIL_KEY, email)
		} else {
			localStorage.removeItem(PENDING_INVITE_EMAIL_KEY)
		}
	} catch (e) {
		console.error('Error storing pending invite email in localStorage:', e)
	}
}

export function clearPendingInvite(): void {
	try {
		localStorage.removeItem(PENDING_INVITE_CODE_KEY)
		localStorage.removeItem(PENDING_INVITE_EMAIL_KEY)
		localStorage.removeItem(PENDING_INVITE_CODE_TIMESTAMP_KEY)
	} catch (e) {
		console.error('Error clearing pending invite from localStorage:', e)
	}
}

export function clearStaleInvite(maxAge: number = 60 * 60 * 1000): void {
	try {
		const timestamp = localStorage.getItem(PENDING_INVITE_CODE_TIMESTAMP_KEY)
		if (timestamp) {
			const age = Date.now() - parseInt(timestamp, 10)
			if (age > maxAge) {
				clearPendingInvite()
			}
		}
	} catch (e) {
		console.error('Error clearing stale invite from localStorage:', e)
	}
}


export function hasPendingInvite(): boolean {
	return getPendingInviteCode() !== null
}

